import type { FaireProductEntity } from "../../entity_types/product";

export const p_4wppra3b8y: FaireProductEntity = {
  token: "p_4wppra3b8y",
  type: "product",
  name: "THRASHER SKATE MAG RED WALLET",
  brandToken: "b_u8merz42xh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/4eaa8be621ad8b0858d47273897c8d14170da891209ab595bae794c12546f56a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ac5d5257c0644645a7b2023bd0ac0d92cc7ccad8e6e20fdc482aebf9253dd9db.jpeg",
  ],
  priceDollars: 21.5,
  description:
    "Carry your cash and cards in style with this lightweight Thrasher Skate Mag trifold wallet. Built from durable nylon with a secure velcro closure, it keeps your essentials organized with dedicated card slots. Compact enough to slip into any pocket, perfect for skate sessions, street runs, or just keeping your lunch money safe.\n",
  tags: [],
  msrpDollars: 43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:27.950Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
